import { COLOR_MAP } from "../ColorNames"

export const DropUp = ({ height = '16', width = '16', stroke = COLOR_MAP.DARK_PURPLE }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.64645 4.98043C7.84171 4.78517 8.15829 4.78517 8.35355 4.98043L12.3536 8.98043C12.5488 9.17569 12.5488 9.49228 12.3536 9.68754C12.1583 9.8828 11.8417 9.8828 11.6464 9.68754L8 6.04109L4.35355 9.68754C4.15829 9.8828 3.84171 9.8828 3.64645 9.68754C3.45118 9.49228 3.45118 9.17569 3.64645 8.98043L7.64645 4.98043Z" fill={stroke} />
    </svg>
  )
}